// extracted by mini-css-extract-plugin
export default {"wrapper":"QuotaCleanerYearFilterPromo__wrapper--3h8S3","text":"QuotaCleanerYearFilterPromo__text--3YVsi","closeIcon":"QuotaCleanerYearFilterPromo__closeIcon--l5JLi"};